module.exports = __webpack_public_path__ + "img/shipping-methods-global.bb7b036.png";